export interface NewsItemImageIdResponseApi {
  newsImageId: string;
}

export let isNewsItemImageIdResponseDTO = (
  variable: unknown
): variable is NewsItemImageIdResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "newsImageId" in variable &&
    typeof variable.newsImageId === "string"
  );
};
